import TopBar from "../components/TopBar";
import Navbar from "../components/Navbar";

function PublicLayout({ children }) {
  return (
    <div className="app">
      <TopBar />
      <Navbar />
      <main>{children}</main>
    </div>
  );
}

export default PublicLayout;